'use strict'

/**
 * View Home
 */

import gsap from 'gsap'

import master from 'Modules/master'
import carousel from 'Modules/carousel'
import rollingTexts from 'Modules/rollingTexts'
import rotateReassurance from '../Modules/rotateReassurance'
import { PopIn3M } from 'Modules/fusion3m'
import responsive from 'Helpers/responsive'

master.process()
carousel.activerCarrouselInfluenceurs()
carousel.activerCarouselHomeAmbianceVentelash()
carousel.activerCarrouselInfluenceuses()
rollingTexts.init()
rotateReassurance.init()

/**
 * Fonction qui gère l'animation des marques dans "Marques du moment"
 */
function gSlider() {
    function getDeviceType() {
        const width = window.innerWidth
        if (width <= 768) {
            return 'mobile'
        } else if (width <= 1024) {
            return 'tablet'
        } else {
            return 'desktop'
        }
    }

    const additionalY = { val: 0 }
    let offset = 0
    const cols = gsap.utils.toArray('.vertical-slider__col')

    cols.forEach((col, i) => {
        const images = col.childNodes

        // DUPLICATE IMAGES FOR LOOP
        images.forEach((image) => {
            var clone = image.cloneNode(true)
            col.appendChild(clone)
        })

        // SET ANIMATION
        images.forEach((item) => {
            let columnHeight = item.parentElement.clientHeight
            let direction = i % 2 !== 0 ? '+=' : '-=' // Change direction for odd columns
            let deviceType = getDeviceType()
            let duration

            switch (deviceType) {
                case 'mobile':
                    duration = 60 // ajustez la durée pour les appareils mobiles
                    break
                case 'tablet':
                    duration = 60 // ajustez la durée pour les tablettes
                    break
                case 'desktop':
                default:
                    duration = 60 // ajustez la durée pour les autres appareils
                    break
            }

            gsap.to(item, {
                y: direction + Number(columnHeight / 2),
                duration: duration,
                repeat: -1,
                ease: 'none',
                modifiers: {
                    y: gsap.utils.unitize((y) => {
                        if (direction == '+=') {
                            offset += additionalY.val
                            y = (parseFloat(y) - offset) % (columnHeight * 0.5)
                        } else {
                            offset += additionalY.val
                            y =
                                (parseFloat(y) + offset) %
                                -Number(columnHeight * 0.5)
                        }

                        return y
                    })
                }
            })
        })
    })
}

// Déclaration de la variable isLoadEncard initialisée à false
let isLoadEncard = false

const isMobile = responsive.isMobile()

// Ajout d'un écouteur d'événements pour le défilement de la fenêtre
window.addEventListener('scroll', function (e) {
    // Chargement des encarts en dessous de la ligne de flottaison
    // Vérifie si aucun élément avec la classe "contain-encarts" n'est trouvé et si isLoadEncard est false
    if ($('.contain-encarts').length == 0 && isLoadEncard == false) {
        isLoadEncard = true // Met isLoadEncard à true pour indiquer que le chargement est en cours

        // Effectue une requête AJAX pour charger les encarts
        $.ajax({
            url: '/Home/LoadEncarts?isMobile=' + isMobile,
            dataType: 'html',
            type: 'post',
            success: function (responseHtml) {
                $('.listencarts').show() //Affiche l'élément ayant la classe "listencarts"
                $('.listencarts').html(responseHtml) // Remplace le contenu de l'élément "listencarts" par le HTML reçu

                carousel.activerCarrouselInfluenceuses()
                // Importe le module "personnalShoppingSelection" et initialise son composant par défaut
                import('Modules/personnalShoppingSelection').then(
                    (personnalShoppingSelection) => {
                        personnalShoppingSelection.default.init(
                            '#appPersonnalShoppingSelection'
                        )
                    }
                )

                // Pop In 3M
                new PopIn3M('#modal-3m')
                    .setEvent('click')
                    .setEventElement('.fusion3MManuel')
                    .build()

                // Appelle les fonctions setPadding() et gSlider()
                setPadding()

                setTimeout(function () {
                    gSlider()
                    master.setDataLinks()
                }, 500)
            },
            error: function () {
                isLoadEncard = false // Réinitialise isLoadEncard à false en cas d'erreur lors du chargement
            }
        })
    }
})

/* permet d'avoir le même padding/margin left sur pershop par rapport a saison */
function setPadding() {
    const windowWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
    const saisonWrapper = document.querySelector('.saison-wrapper')
    const pershopIntro = document.querySelector('.pershop__intro')

    if (windowWidth > 1600 && isLoadEncard && saisonWrapper && pershopIntro) {
        const marginLeftValue = window
            .getComputedStyle(saisonWrapper)
            .getPropertyValue('margin-left')
        pershopIntro.style.paddingLeft = marginLeftValue
    }
}

// Ajout de l'événement resize une seule fois
window.addEventListener('resize', setPadding)

/* read more  */
function setupReadMore(
    buttonSelector,
    contentSelector,
    activeClass,
    container
) {
    const button = $(buttonSelector)

    button.on('click', function (event) {
        const jKeywordReadMore = event.target
            .closest(contentSelector)
            .querySelector(container)

        if (!jKeywordReadMore) {
            return
        }

        jKeywordReadMore.classList.toggle(activeClass)

        if (jKeywordReadMore.classList.contains(activeClass)) {
            button.text($t('VOIR_MOINS'))
        } else {
            button.text($t('VOIR_PLUS'))
        }
    })
}

// Voir plus marques
setupReadMore(
    '.keywords__cta',
    '.keywords__list--child',
    'active',
    '.j_KeywordReadMore'
)

// Voir plus présentation Modz
setupReadMore(
    '.prez-modz__cta',
    '.wrapper__prez-modz',
    'active',
    '.j_keywordTxtReadMore'
)
